import classNames from 'classnames';
import styles from '@/styles/components/sticky-bar.module.scss';
import React, { FC, memo, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { shallowEqual, useSelector } from 'react-redux';
import { AppState } from '@/store';
import Image from 'next/image';
import dayjs from 'dayjs';

const StickyBar: FC<any> = memo(props => {
  const [isCloseStickyBar, setIsCloseStickyBar] = useState<boolean>(true);
  const { stickyBar } = props;

  useEffect(() => {
    setIsCloseStickyBar(false);
    const isCloseStickyData = localStorage.getItem('isCloseStickyBar');
    const isCloseStickyBarTimeData = localStorage.getItem('isCloseStickyBarTime');
    const isCloseStickyBarTime = dayjs(isCloseStickyBarTimeData).valueOf().toString();
    if (isCloseStickyData && isCloseStickyBarTime) {
      const currentTime = new Date().getTime();
      const expirationTime = 24 * 60 * 60 * 1000;
      if (currentTime - parseInt(isCloseStickyBarTime, 10) > expirationTime) {
        localStorage.removeItem('isCloseStickyBar');
        localStorage.removeItem('isCloseStickyBarTime');
        setIsCloseStickyBar(false);
      } else {
        setIsCloseStickyBar(true);
      }
    }
  }, []);

  const handleClose = () => {
    const currentTime = new Date().getTime();
    const currentTimeString = dayjs(currentTime).format('YYYY-MM-DDTHH:mm:ssZ').toString();
    localStorage.setItem('isCloseStickyBar', 'true');
    localStorage.setItem('isCloseStickyBarTime', currentTimeString);
    setIsCloseStickyBar(true);

    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'sticky_bar',
      pageURL: window.location.href,
      componentName: 'sticky bar'
    });
  };

  if (isCloseStickyBar) {
    return null;
  }

  return (
    <>
      {stickyBar.announcement ? (
        <div
          className={classNames(styles.Sticky_Bar_Display, {
            [styles.Is_Display]: !isCloseStickyBar
          })}
        >
          <div className={styles.Sticky_Bar}>
            <div className={styles.Container}>
              <p className={styles.Content}>{stickyBar.announcement}</p>
              <Image
                onClick={() => handleClose()}
                src="/blog/icon/Close.svg"
                className={styles.Close_Button}
                alt={''}
                width={11}
                height={10}
              />
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export default StickyBar;
